import { observable, action, runInAction } from 'mobx'
import store from '../store'
import myStore from '../Search/store'
import { toJS } from 'mobx'
import Api from '@api/hotel/CalendarModeApi'

class Store {
  @observable date = []
  @observable entity_id = ''
  @observable
  modal = {
    title: '',
    visible: false
  }
  @action
  setDate(key, date) {
    this.date = date
    this.entity_id = key
    this.getList()
    Object.assign(this.modal, {
      title: date.format('YYYY-MM-DD'),
      visible: true
    })
  }
  @observable list = []
  @observable loading = false
  @action
  async getList() {
    let params = this.getSearchParams()
    let {
      data: { list = [] }
    } = await Api.getListMode(params)
    this.loading = true
    runInAction('list', () => {
      this.list = list
      this.loading = false
    })
  }
  //关闭
  @action
  cancel = () => {
    Object.assign(this.modal, {
      visible: false
    })
    myStore.getList()
  }
  getSearchParams() {
    const { entity_id, date } = this
    return {
      entity_id: Number(entity_id),
      date_min: date.format('YYYY-MM-DD'),
      date_max: date.format('YYYY-MM-DD'),
      is_all: 1
    }
  }
  //获取宴会厅信息
  @action
  getEntity() {
    const { hotelHalls } = store
    let entity = {}
    hotelHalls.forEach(item => {
      entity[item.id] = {
        name: item.name,
        max_table_num: item.max_table_num,
        best_table_num: item.best_table_num,
        area: item.area,
        height: item.height
      }
    })
    return entity
  }
  //获取日期标记样式类型
  @action
  getCalendarInfo(key, value) {
    const { list } = myStore
    let listData = toJS(list)
    let itemColor = []
    let data = listData[key]
    for (let i in data) {
      data[i].item[0].forEach(i => {
        if (i) {
          if (value.format('YYYY-MM-DD') == i.date && i.time_str == ',1,') {
            itemColor.push({ type: 'lunch' })
          } else if (
            value.format('YYYY-MM-DD') == i.date &&
            i.time_str == ',2,'
          ) {
            itemColor.push({ type: 'dinner' })
          } else if (
            value.format('YYYY-MM-DD') == i.date &&
            (i.time_str == ',1,2,' || i.time_str == ',2,1,')
          ) {
            itemColor.push({ type: 'dinner' })
            itemColor.push({ type: 'lunch' })
          }
        }
      })
    }
    return itemColor
  }
}

export default new Store()
